<template lang="pug">
  .flipUnitContainer
    static-card(
      position="upperCard"
      :digit="currentDigit"
    )
    static-card(
      position="lowerCard"
      :digit="previousDigit"
    )
    animated-card(
      :digit="digit1"
      :animation="animation1"
    )
    animated-card(
      :digit="digit2"
      :animation="animation2"
    )
</template>

<script>
  import StaticCard from "./StaticCard";
  import AnimatedCard from "./AnimatedCard";
  export default {
    name: "FlipUnitContainer",
    components: {AnimatedCard, StaticCard},
    props: {
      digit: {
        type: Number,
        required: true
      },
      shuffle: {
        type: Boolean,
        required: true
      },
      unit: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        currentDigit: null,
        previousDigit: null,
        digit1: null,
        animation1: '',
        digit2: null,
        animation2: ''
      }
    },
    mounted() {
      this.setCurrentDigit()
    },
    watch: {
      digit() {
        this.setCurrentDigit()
      }
    },
    methods: {
      setCurrentDigit() {
        // assign digit values
        let currentDigit = this.digit;
        let previousDigit = this.digit + 1;

        // to prevent a negative value
        if (this.unit === 'seconds' || this.unit === 'minutes') {
          previousDigit = previousDigit === -1
            ? 59
            : previousDigit;
        }

        if (this.unit === 'hours') {
          previousDigit = previousDigit === -1
            ? 23
            : previousDigit;
        }

        if (this.unit === 'days') {
          previousDigit = previousDigit === -1
            ? 0
            : previousDigit;
        }

        // add zero
        if ( currentDigit < 10 ) {
          currentDigit = `0${currentDigit}`;
        }
        if ( previousDigit < 10 ) {
          previousDigit = `0${previousDigit}`;
        }

        this.previousDigit = previousDigit
        this.currentDigit = currentDigit

        // shuffle digits
        this.digit1 = this.shuffle
          ? previousDigit
          : currentDigit;
        this.digit2 = !this.shuffle
          ? previousDigit
          : currentDigit;

        // shuffle animations
        this.animation1 = this.shuffle
          ? 'fold'
          : 'unfold';
        this.animation2 = !this.shuffle
          ? 'fold'
          : 'unfold';
      }
    }
  }
</script>

<style scoped lang="scss">

</style>